// DS6.2
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import FolderLink from './_partials/FolderLink';
import FolderCardFooter from './_partials/FolderCardFooter/FolderCardFooter';
import FolderCardContent from './_partials/FolderCardContent';
import FolderCardLayout from './_partials/FolderCardLayout';
import FolderRibbon from '../Primitives/FolderRibbon';
import { isPlainClick } from '../utils/clickHelpers';
import { getFooterHeight, getFooterMargin, getPadding, shouldShowStats } from './helpers';
import s from './FolderCard.scss';
export const FOLDER_CARD_ASPECT_RATIO = 1.18;
const preventDefault = (e)=>!e.metaKey && !e.ctrlKey && e.preventDefault();
const stopPropagation = (e)=>e.stopPropagation();
export const FolderCard = (_param)=>{
    var { extras, folder, hasSubfolders, isLocked, onClick, width, withPremiumShownNextToTitle, showCountsWithoutCaptions, oneLineDescription, withLink, withPrice } = _param, props = _object_without_properties(_param, [
        "extras",
        "folder",
        "hasSubfolders",
        "isLocked",
        "onClick",
        "width",
        "withPremiumShownNextToTitle",
        "showCountsWithoutCaptions",
        "oneLineDescription",
        "withLink",
        "withPrice"
    ]);
    const height = width / FOLDER_CARD_ASPECT_RATIO;
    const previewWidth = width - getPadding();
    const previewHeight = height - getPadding() - getFooterMargin() - getFooterHeight(height);
    var _folder_totalItemCount, _ref;
    const folderSize = (_ref = (_folder_totalItemCount = folder.totalItemCount) !== null && _folder_totalItemCount !== void 0 ? _folder_totalItemCount : folder.size) !== null && _ref !== void 0 ? _ref : 0;
    return /*#__PURE__*/ React.createElement(FolderCardLayout, _object_spread_props(_object_spread({
        folder: folder,
        width: width,
        height: height,
        wrapCondition: withLink,
        wrap: (child)=>/*#__PURE__*/ React.createElement(FolderLink, {
                className: s['folder-link'],
                onClick: onClick ? preventDefault : undefined,
                folder: folder
            }, child),
        content: /*#__PURE__*/ React.createElement(FolderCardContent, {
            width: previewWidth,
            height: previewHeight,
            folder: folder,
            hasSubfolders: hasSubfolders,
            totalDeviationCount: folderSize
        }),
        ribbon: folder.premiumFolderData && !withPremiumShownNextToTitle && /*#__PURE__*/ React.createElement(FolderRibbon, {
            premiumFolderData: folder.premiumFolderData
        }),
        footer: /*#__PURE__*/ React.createElement(FolderCardFooter, {
            folder: folder,
            isLocked: isLocked,
            showCountsWithoutCaptions: showCountsWithoutCaptions,
            withPremiumShownNextToTitle: withPremiumShownNextToTitle,
            withPrice: withPrice,
            oneLineDescription: oneLineDescription,
            hideStats: !shouldShowStats(height)
        }, extras && /*#__PURE__*/ React.createElement("span", {
            className: s['extras'],
            onClick: stopPropagation
        }, extras))
    }, props), {
        onClick: (e)=>{
            if (!onClick) {
                return;
            }
            // ctrl/cmd clicks open the link, but don't fire onClick handler
            if (withLink && !isPlainClick(e)) {
                return;
            }
            onClick();
        }
    }));
};
export default FolderCard;
